import Vue from 'vue';
import "../../common/vue/common";
import App from './app-vue.vue';
import AppConfig from "~/appConfig";
import AppRouter from "~/vueRouter/appRouter";
import routes from "./routes/routes";
import User from "../../common/models/user";
import store from "../../common/state/store";
import Selected from "./store/modules/selected";
import Organization from "../../common/models/organization";
import StoreFactory from "./store/storeFactory";
import ListView from "../../common/models/listViews/listView";
import DetailView from "../../common/models/detailView/detailView";
import ObjectModelEntry from "../../common/models/objectModelEntries/objectModelEntry";
import ListViewContentElementBase from "./components/list-view-content-element-base.vue";
import DetailViewContentElementBase from "./components/detail-view-content-element-base.vue"
import DetailViewEditElementBase from "./components/detail-view-edit-element-base.vue"
import ContextMixin from "./mixins/contextMixin";
import SelectedMixin from "./mixins/selectedMixin";
import ListViewFilterBase from "./components/list-view-filter-base.vue";
import {RouteHelper} from "../../common/helpers/routeHelper";
import {Route} from "../../common/enums/route";
import PublishedListView from "../../common/models/listViews/publishedListView";
import PublishedDetailView from "../../common/models/detailView/publishedDetailView";
import '../../common/froala';
import VueEventsMixin from "~/mixins/vueEventsMixin";
import ListViewCan from '~/abilities/listViewCan';
import Folder from '../document_management/models/folder';
import ObjectModelPermissionsCan from "~/abilities/objectModelPermissionsCan";

Vue.use(AppRouter);
Vue.component("detail-view-content-element-base", DetailViewContentElementBase);
Vue.component("detail-view-edit-element-base", DetailViewEditElementBase);
Vue.component("list-view-content-element-base", ListViewContentElementBase);
Vue.component("list-view-filter-base", ListViewFilterBase);

const onReady = function () {
  window.AppConfig = new AppConfig();

  const $rootElement = $(document).find('#vue-data');
  const user = new User().loadFromJson($rootElement.data('user'));
  Selected.currentUser.set(user);

  const organization = new Organization().loadFromJson($rootElement.data('organization'));
  Selected.organization.set(organization);

  const listViewData = $rootElement.data('listView');
  if (listViewData) {
    const listView = new ListView().loadFromJson(listViewData);
    Selected.listView.set(listView);
    listView.organization = organization;
  }
  const publishedListViewData = $rootElement.data('publishedListView');

  if (publishedListViewData) {
    const folder = new Folder().loadFromJson($rootElement.data('publishedListView').folder)
    const publishedListView = new PublishedListView().loadFromJson(publishedListViewData);
    Selected.publishedListView.set(publishedListView);
    publishedListView.organization = organization;
    publishedListView.folder = folder
  }
  let publishedDetailView

  const detailViewData = $rootElement.data('detailView');
  const publishedDetailViewData = $rootElement.data('publishedDetailView');
  if (publishedDetailViewData) {
    publishedDetailView = new PublishedDetailView().loadFromJson(publishedDetailViewData);
    Selected.publishedDetailView.set(publishedDetailView);
    publishedDetailView.organization = organization;
  }else if(detailViewData){
    const detailView = new DetailView().loadFromJson(detailViewData);
    Selected.unpublishedDetailView.set(detailView);
    detailView.organization = organization;
  }

  const objectModelEntryData = $rootElement.data('objectModelEntry');
  if (objectModelEntryData) {
    const objectModelEntry = new ObjectModelEntry().loadFromJson(objectModelEntryData);
    Selected.objectModelEntry.set(objectModelEntry);
    if (!!publishedDetailView?.objectModel){
      objectModelEntry.published_object_model = publishedDetailView.objectModel;
    }
  }

  const dashboardDrilldownFilters = $rootElement.data('dashboardDrilldownFilters');
  Vue.use(new ListViewCan(user));
  Vue.use(new ObjectModelPermissionsCan(user));
  Vue.mixin(SelectedMixin);
  Vue.mixin(ContextMixin);
  Vue.mixin(VueEventsMixin);

  const breadcrumbs = $rootElement.data('breadcrumbs');
  const router = new AppRouter({
    base: RouteHelper.path({route: Route.root}),
    routes: routes,
    mode: 'history',
  });
  const params = new URLSearchParams(window.location.search);
  const flashType = params.get('flashType') ? params.get('flashType') : 'notice';
  const initialFlash = params.get('flash') ? { [flashType] : params.get('flash')} : {};
  //Use job_ids in params if it there to subscribe to jobsChannel in view-detail-view, but delete it from url to prevent view-detail-view from resubscribing to old jobs
  const handleChangesJobIds = ['', null, undefined].includes(params.get('job_ids')) ? [] : JSON.parse(params.get('job_ids'))
  router.onReady(() => {
    const query = Object.assign({}, router.currentRoute.query);
    delete query.flash;
    delete query.flashType;
    delete query.job_ids;
    router.replace({query});
  });
  StoreFactory.registerModules(router, initialFlash, breadcrumbs, Selected.objectModelEntry.get(), handleChangesJobIds, organization.time_zone, dashboardDrilldownFilters);

  new Vue({
    el: "#vue-data",
    render: h => h(App, {}),
    store: store,
    router,
  });
};

$(onReady);
